import React from 'react';

import moment from 'moment';
import { observer } from 'mobx-react'

import { makeStyles } from '@material-ui/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Card from '@material-ui/core/Card';


import ObjectsVirtualizedTable, {createDefaultCellRenderer} from 'components/ObjectsVirtualizedTable';


const useCardStyles = makeStyles({
  root: {
    width: 200,
    margin: 5
  },
  media: {
    height: 80,
  },
});


export const PromotionCard = ({promotion, onClick}) => {
  const classes = useCardStyles()
  
  const imageUrl = promotion.imageContainer.imageUrl

  return <Card className={classes.root} onClick={onClick}>
      <CardActionArea>
        {imageUrl ? <CardMedia
          className={classes.media}
          image={imageUrl}
         
        />: null}
      </CardActionArea>
    </Card>;
}


// dataKey: 'name',

const PromotionsTableVirtualized = observer(({ store, onSort, onSelectObject, className, ...rest }) => {

    const results = store.selectObjectsState.objects;
    
    const onSelectRow = (rowData)=> {
        onSelectObject(rowData.obj.id);
    }

    const getRowData = ({ index }) => {
        const obj = results[index]
        const name = obj.name
        const id = obj.id
        const publishStartDateTime = moment(obj.publishStartDateTime).format('DD/MM/YYYY HH:mm')
        const publishEndDateTime = obj.publishEndDateTime ? moment(obj.publishEndDateTime).format('DD/MM/YYYY HH:mm') : ""
        const contentObjectName = obj.publishedContentObject ? obj.publishedContentObject.name : ""
        const isDefault = obj.isDefault ? 'yes' : ''
        return { id, name, contentObjectName, publishStartDateTime, publishEndDateTime, isDefault, obj }
    }

    const sort = (column) => {
        if (onSort) {
            onSort(column)
        }
    }

    const columns = [
        {
            width: 400,
            label: 'Promotion',
            dataKey: 'obj',
            renderCell: ({ rowData, cellData }) => (<PromotionCard promotion={cellData} onClick={() => onSelectRow(rowData)} />),
            rowClick: true      
        },
        {
            width: 200,
            label: 'Name',
            dataKey: 'name',
            sort: () => sort('name')
        },
        {
            width: 200,
            label: 'Publish start date',
            dataKey: 'publishStartDateTime',
        },
        {
            width: 200,
            label: 'Publish end date',
            dataKey: 'publishEndDateTime',
        },
        {
            width: 200,
            label: 'Linked object',
            dataKey: 'contentObjectName'
        },
        {
            width: 100,
            label: 'Default',
            dataKey: 'isDefault',
        },
        {
            width: '100%',
            label: 'Actions',
            dataKey: 'id',
        },
    ]
    
    const onDelete = (objectId) => {
        if (window.confirm("Do you really want to delete your this promotion?")) {
            store.delete(objectId);
        }
    }

    

    const cellRenderer = createDefaultCellRenderer({ columns, actionColumnIndex: 6, onDelete, onSelectRow, rowHeight: 120});


    return  <ObjectsVirtualizedTable 
        store={store} 
        columns={columns} 
        getRowData={getRowData}
        cellRenderer={cellRenderer}
        rowHeight={96}
    />

    
});

export default PromotionsTableVirtualized;